package com.essntl.features.request.ui.addeditrequest.components

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.TransformOrigin
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsRichInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.ksoup.html.parser.KsoupHtmlHandler
import com.mohamedrejeb.ksoup.html.parser.KsoupHtmlParser
import com.mohamedrejeb.richeditor.model.rememberRichTextState

@Composable
fun RequestEmailInformation(
    request: RequestModel,
) {
    var isExpanded by rememberSaveable { mutableStateOf(true) }

    var from by remember { mutableStateOf("") }
    val richTextState = rememberRichTextState()

    val handler = KsoupHtmlHandler
        .Builder()
        .onOpenTag { name, attributes, _ ->
            when (name.lowercase()) {
                "a" -> {
                    if (from.isEmpty() && !attributes["href"].isNullOrEmpty())
                        if (attributes["href"]!!.length > 7)
                            from = attributes["href"]?.substring(7) ?: ""
                }
            }
        }.build()

    val parser = KsoupHtmlParser(
        handler = handler,
    )

    parser.write(request.htmlEmail ?: "")
    parser.end()

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(
                color = MaterialTheme.esColorScheme.bgSecondary,
                shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
            )
            .padding(
                vertical = 3.spacing,
                horizontal = 2.5f.spacing,
            ),
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Text(
                text = "Email Information",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.s2SemiBold16,
            )

            EsLargeIcon(
                res = EsIcons.ArrowDown,
                modifier = Modifier
                    .graphicsLayer {
                        transformOrigin = TransformOrigin.Center
                        rotationZ = if (isExpanded) 180f else 0f
                    }
                    .clip(CircleShape)
                    .pointerHoverIcon(PointerIcon.Hand)
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                    ) {
                        isExpanded = !isExpanded
                    },
            )
        }

        AnimatedVisibility(isExpanded) {
            Column(
                modifier = Modifier
                    .fillMaxWidth(),
            ) {
                Spacer(modifier = Modifier.height(3.spacing))
                Box(
                    modifier = Modifier
                        .shadow(
                            elevation = 1.5.spacing,
                            spotColor = Color(0x1A000000),
                            ambientColor = Color(0x1A000000),
                            shape = RoundedCornerShape(size = 2.spacing),
                        )
                        .fillMaxSize()
                        .background(
                            color = Color.White,
                            shape = RoundedCornerShape(size = 2.spacing),
                        )
                        .padding(2.spacing),
                ) {
                    Text(
                        text = "from: $from",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.p2Medium14,
                        modifier = Modifier.align(Alignment.CenterStart),
                    )
                }

                Spacer(modifier = Modifier.height(3.spacing))

                request.htmlEmail?.let {
                    richTextState.setHtml(it)
                }

                EsRichInput(
                    richTextState = richTextState,
                    placeholder = "Add here some description for the service",
                    enabled = false,
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = 100.dp),
                )
            }
        }
    }
}